var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SetUserLocale } from 'src/app/auth/state/auth/auth.actions';
import { locales } from 'src/app/locale-config.module';
import { DialogService } from 'src/app/dialogs/dialog.service';
var LocaleMenuComponent = /** @class */ (function () {
    function LocaleMenuComponent(store, dialogService) {
        this.store = store;
        this.dialogService = dialogService;
        this.ngUnsubscribe = new Subject();
        this.locales = locales;
    }
    LocaleMenuComponent.prototype.ngOnInit = function () {
    };
    LocaleMenuComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LocaleMenuComponent.prototype.handleLocaleSelected = function (locale) {
        var _this = this;
        var dialogRef = this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Confirm Language Selection',
                bodyText: "Your language will be changed to \"" + locale.title + "\"?",
                confirmText: 'Set Language',
                confirmColor: 'warn'
            }
        });
        dialogRef.afterClosed()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (confirmed) {
            if (confirmed) {
                _this.store.dispatch(new SetUserLocale(locale));
                window.location.reload();
            }
        });
    };
    __decorate([
        Select(AuthState.getUserLocale),
        __metadata("design:type", Observable)
    ], LocaleMenuComponent.prototype, "userLocale$", void 0);
    return LocaleMenuComponent;
}());
export { LocaleMenuComponent };
